enum ListingCardTypeEnum {
  Product = 'product',
  Promo = 'promo',
  Article = 'article',
}

export default ListingCardTypeEnum;
